import React from 'react';
import { Loader2 } from 'lucide-react';

export const WordEntryStatus = ({ data, testId = 'word-entry-status' }) => {
  if (!data?.error && !data?._details_loading && !data?._details_error) return null;
  return (
    <div role="status" aria-live="polite" data-testid={testId} className="flex items-center gap-2 px-4 py-2 text-xs text-muted-foreground shrink-0">
      {data._details_loading && <Loader2 className="h-3 w-3 shrink-0 animate-spin" aria-hidden="true" />}
      <span>{data.error ? 'Word details could not be loaded.' : data._details_loading ? 'Loading additional details…' : 'Additional details are temporarily unavailable.'}</span>
    </div>
  );
};